import { useMemo } from "react";
import { Trans, useTranslation } from "react-i18next";
import { buildHistorySentence } from "../../utils/buildHistorySentence";
import type { HistorySentenceProps } from "./types";

export const HistorySentence = ({
  summary,
  planCount,
}: HistorySentenceProps) => {
  const { t } = useTranslation();

  const { key, params } = useMemo(
    () =>
      buildHistorySentence({
        summary,
        planCount,
        unknownTypeLabel: t("smartSurveyor.history.removedType"),
      }),
    [summary, planCount, t],
  );

  // Names are escaped before the <b> markup is parsed, so a "<" in a type name stays text.
  return (
    <Trans
      i18nKey={`smartSurveyor.history.sentence.${key}`}
      values={params}
      components={{ b: <span className="font-semibold" /> }}
      tOptions={{ interpolation: { escapeValue: true } }}
      shouldUnescape
    />
  );
};
